import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listData: [],
  copyListData: [],
  ownerList: [],
  appointmentList: [],
  appointmentStatus: [],
};

export const listSlice = createSlice({
  name: "listSlice",
  initialState,
  reducers: {
    setListData: (state, action) => {
      state.listData = action.payload;
    },
    setResultListData: (state, action) => {
      state.resultListData = action.payload;
    },
    setCopyResultListData: (state, action) => {
      state.copyResultListData = action.payload;
    },
    setCopyListData: (state, action) => {
      state.copyListData = action.payload;
    },
    setAppointmentList: (state, action) => {
      state.appointmentList = action.payload;
    },
    setOwnerList: (state, action) => {
      state.ownerList = action.payload;
    },
    setAppointmentStatus: (state, action) => {
      state.appointmentStatus = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setListData,
  setAppointmentList,
  setOwnerList,
  setCopyListData,
  setAppointmentStatus,
  setCopyResultListData,
  setResultListData,
} = listSlice.actions;

export default listSlice.reducer;
